import React, { FC } from 'react';

import classNames from 'classnames';

export enum HeaderSize {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  HERO = 'hero',
}

export interface HeaderInterface {
  omitSizeString?: boolean;
  size: HeaderSize;
  text: any;
  applyUpperCasing?: boolean;
  align?: 'left' | 'center' | 'right';
  classes?: string;
  role?: string;
  isFullWidth?: boolean;
  hoverEffect?: boolean;
}

const mapSizeToClassName = {
  h1: 'text-h-x3 md:text-h-x2',
  h2: 'text-h-x4 md:text-h-x3',
  h3: 'text-h-x5 md:text-h-x4',
  h4: 'text-h-x6 md:text-h-x6',
  hero: 'text-h-x3 md:text-h-x1',
};

const HeaderText: FC<HeaderInterface> = ({
  omitSizeString,
  size = HeaderSize.H1,
  text,
  align,
  classes = '',
  role = 'heading',
  applyUpperCasing,
  isFullWidth = true,
  hoverEffect,
}) => {
  if (!text) {
    return null;
  }

  const element = size == HeaderSize.HERO ? 'h1' : size;

  return React.createElement(
    element,
    {
      role,
      className: classNames('font-bold', {
        [classes]: classes,
        'text-charcoal-v2': !hoverEffect,
        'w-full': isFullWidth,
        'title-container': align === 'center',
        [`text-${align}`]: align,
        [mapSizeToClassName[size]]: !omitSizeString,
        uppercase: applyUpperCasing,
      }),
      'data-testid': `text-headerText-${size}`,
    },
    text,
  );
};

export default React.memo(HeaderText);
